import { QueryClient, type UseQueryOptions as UseTanstackQueryOptions } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      staleTime: 1000 * 60 * 5, // 5 minutes,
    },
  },
});

export type UseQueryOptions<T, U, V = {}> = Omit<UseTanstackQueryOptions<T, Error, U>, "queryKey" | "queryFn"> & {
  params?: V;
};
